import React from "react";
import "./sectionTemplate.scss";

function SectionTemplate({ templatetitle }) {
  return templatetitle ? (
    <div className="section-saved-tamplate-wrapper">
      <div className="section-tamplate-title">Template : {templatetitle}</div>
    </div>
  ) : null;
}

export default SectionTemplate;
